import React, { useState } from 'react';
import { FileText, PenSquare, Save, X } from 'lucide-react';
import { actualizarMatricula } from '../../services/matriculaService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Antecedentes = ({ matricula }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    institucion_anterior: matricula.antecedentes?.institucion_anterior || '',
    expectativas: matricula.antecedentes?.expectativas || ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      await actualizarMatricula(matricula.nino.id_child, {
        antecedentes: formData
      });
      setIsEditing(false);
      matricula.antecedentes = formData;
      toast.success('Antecedentes actualizados exitosamente', {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    } catch (error) {
      console.error('Error al actualizar:', error);
      toast.error('Error al actualizar los datos: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    }
  };

  const inputStyle = "w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center">
          <FileText className="mr-2 text-indigo-500" size={20} />
          Antecedentes
        </h3>
        {!isEditing ? (
          <PenSquare 
            className="text-indigo-500 cursor-pointer hover:text-indigo-600" 
            size={20} 
            onClick={() => setIsEditing(true)}
          />
        ) : (
          <div className="flex gap-2">
            <Save 
              className="text-green-500 cursor-pointer hover:text-green-600" 
              size={20} 
              onClick={handleSubmit}
            />
            <X 
              className="text-red-500 cursor-pointer hover:text-red-600" 
              size={20} 
              onClick={() => setIsEditing(false)}
            />
          </div>
        )}
      </div>

      <div className="space-y-3">
        <div>
          <span className="text-sm font-medium text-gray-500">Institución anterior:</span>
          {isEditing ? (
            <input
              name="institucion_anterior"
              value={formData.institucion_anterior}
              onChange={handleInputChange}
              className={inputStyle}
              placeholder="Institución anterior"
            />
          ) : (
            <p className="text-gray-900">{matricula.antecedentes?.institucion_anterior || 'Ninguna'}</p>
          )}
        </div>
        <div>
          <span className="text-sm font-medium text-gray-500">Expectativas:</span>
          {isEditing ? (
            <textarea
              name="expectativas"
              value={formData.expectativas}
              onChange={handleInputChange}
              className={`${inputStyle} h-24`}
              placeholder="Expectativas"
            />
          ) : (
            <p className="text-gray-900">{matricula.antecedentes?.expectativas || 'No especificadas'}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Antecedentes;
